import React from 'react'
import Content from './Content'
function Gallery() {
  return (
    <div className="container mx-auto m-4 z-10 text-center">
            <Content isColor={true} title="HOTEL IMAGES"
            subtitle="Our Gallery"
            />
            
          </div>
  )
}

export default Gallery